import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import ArticleBreadcrumbs from './common/ArticleBreadcrumbs.react';
import ArticleParagraph from './common/ArticleParagraph.react';
import Img from '../common/Img.react';
var PageBanner = function PageBanner(_ref) {
  var _logo$assetID;
  var _id = _ref._id,
    articleType = _ref.articleType,
    banner = _ref.banner;
  var _useParams = useParams(),
    articleID = _useParams.articleID;
  var bucket = useSelector(function (s) {
    return s.config.bucket;
  });
  var filename = banner.filename,
    logo = banner.logo,
    paragraph = banner.paragraph,
    altTag = banner.altTag;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "p-hero"
  }, /*#__PURE__*/React.createElement(Img, {
    src: "".concat(bucket, "/").concat(filename),
    alt: altTag
  })), articleType === 'project' && /*#__PURE__*/React.createElement("section", {
    className: "a"
  }, /*#__PURE__*/React.createElement("div", {
    className: "a__body ".concat(articleID ? 'a__body--wide' : '')
  }, /*#__PURE__*/React.createElement(ArticleBreadcrumbs, {
    _id: _id,
    breadcrumbs: "Main",
    article: false
  }), (logo === null || logo === void 0 ? void 0 : (_logo$assetID = logo.assetID) === null || _logo$assetID === void 0 ? void 0 : _logo$assetID.filename) && /*#__PURE__*/React.createElement("img", {
    className: "p-hero__logo",
    src: "".concat(bucket, "/").concat(logo.assetID.filename)
  }), /*#__PURE__*/React.createElement(ArticleParagraph, {
    paragraph: paragraph
  }))));
};
export default PageBanner;